import { FullHeightContainer } from "./FullHeighContainer";
import { General } from "../../../siteManagement/general";
import React from "react";
import ReactDOM from "react-dom";

export class VerticalTabStrip extends React.Component<VerticalTabStripProps, { activeIndex?: number; }>{
    private _tabStripContentWrapper: JQuery = null;

    constructor(props: VerticalTabStripProps) {
        super(props);
        this.state = {
            activeIndex: this.props.initialActiveIndex || 0
        };
        this._tabStripContentWrapper = General.Sheet.Manager.getTopMostSheet().elements.getLeftDrawerElementRef();
    }

    private _showTab = (index: number) => {
        if (this.state.activeIndex !== index) {
            this.setState({ activeIndex: index }, () => {
                if (this.props.onTabActivated) {
                    this.props.onTabActivated(index);
                }
            });
        }
    }

    private _getTitles = () => {
        return this.props.titles.map((t, i) => {
            return (
                <div key={i} className={"tabstrip__item" + (this.state.activeIndex === i ? " current" : "")} onClick={(e) => this._showTab(i)}>{t}</div>
            );
        });
    }

    private _processTabs = () => {
        const result = { tabs: null, floats: [] };

        result.tabs = React.Children.map(this.props.children, (x, i) => {
            if (typeof x === "string" || typeof x === "number" || (x as any).type !== VerticalTabsStripFloatingContent) {
                return <FullHeightContainer style={{ overflowY: "auto", display: i !== this.state.activeIndex ? "none" : null }}>{x}</FullHeightContainer>
            } else {
                result.floats.push(<div key="i">{x}</div>);

                return null;
            }
        });

        return result;
    }

    render() {
        const parts = this._processTabs();
        return (
            <>
                {ReactDOM.createPortal(this._getTitles(), this._tabStripContentWrapper[0])}
                <FullHeightContainer>
                    {parts.tabs}
                </FullHeightContainer>
                <div style={{ display: "none" }}>{parts.floats}</div>
            </>
        );
    }
}

export class VerticalTabsStripFloatingContent extends React.Component<any, any> {
    render() {
        return (
            <>{this.props.children}</>
        );
    }
}

interface VerticalTabStripProps extends React.PropsWithChildren {
    titles: Array<string>; //React.??
    initialActiveIndex?: number;
    onTabActivated?: (tabIndex: number) => void;
}